const RUDDERSTACK_STORAGE_PREFIXES = ['rudder_'] as const

export default defineNuxtPlugin(() => {
  const { rudderstackWriteKey: writeKey, rudderstackDataPlaneUrl: dataPlaneUrl, env } = useRuntimeConfig().public

  if (!writeKey || !dataPlaneUrl) {
    console.warn('Nuxt Plugin: RudderStack is not properly configured. Skipping initialization.')
    return
  }

  const script = useAnalyticsScript({
    key: 'rudderstack',
    src: 'https://cdn.rudderlabs.com/v3/modern/rsa.min.js',
    storagePrefixes: RUDDERSTACK_STORAGE_PREFIXES,
  })

  const { analytics } = useCookieConsent()

  script.onLoaded(() => {
    if (!analytics.value) {
      return
    }

    window.rudderanalytics?.load(writeKey, dataPlaneUrl, {
      storage: { type: 'none' },
      logLevel: env === 'production' ? 'NONE' : 'ERROR',
    })
    window.rudderanalytics?.page()
  })
})
